import { Text, View, StyleSheet } from "react-native";
import React from "react";
import commonStyles from "../styles";

interface IMicroJobRowHeaderProps {
  microJobRow: any;
}

const MicroJobRowHeader = (props: IMicroJobRowHeaderProps) => {
  const { microJobRow } = props;
  return (
    <View
      style={[
        commonStyles.cardOne,
        {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      ]}
    >
      <View style={[styles.row]}>
        <View style={{ minWidth: "50%", marginLeft: 5 }}>
          <View style={{ flexDirection: "row" }}>
            <View style={{ flexDirection: "row", width: 250 }}>
              <Text style={styles.headText}>Car Part:</Text>
              <Text
                style={[
                  styles.subHeadText,
                  { marginLeft: 10, fontWeight: "bold" },
                ]}
              >
                {microJobRow?.part?.name ?? "N/A"}
              </Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <View>
                <Text style={styles.headText}>Fixes: </Text>
              </View>
              <View style={{ flexDirection: "row" }}>
                <View style={{ marginHorizontal: 5 }}>
                  <Text style={styles.subHeadText}>
                    {microJobRow?.fix?.name}{" "}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  headText: {
    color: "#200E36",
    fontWeight: "bold",
    fontFamily: "Roboto",
  },
  subHeadText: {
    color: "#555555",
    fontFamily: "Roboto",
  },
  row: {
    flex: 1,
    flexDirection: "row",
  },
});

export default MicroJobRowHeader;
